<template>
  <span v-html="cellValue"></span>
</template>
<script>
export default {
  name: 'ContentTableCell',
  props: {
    column: {},
    model: {}
  },
  computed: {
    cellValue() {
      if (this.column.type === 'date' && this.model[this.column.field]) {
        return this.model[this.column.field]['label']
      }
      // Crema: amounts come as numbers, the column says to format them.
      if (this.column.type === 'price') {
        const value = this.model[this.column.field]
        return value === null || value === undefined || value === ''
          ? ''
          : this.$h.formatCurrency(value)
      }
      return this.model[this.column.field]
    }
  }
}
</script>
